import React, { useEffect, useMemo, useState } from 'react';
import ProductsContainer from './Products/ProductsContainer';
import { shopProductsAndCategorySelectorUpdated } from './helpers';
import './Shop.scss';
import productsActions from '../../actions/productsActions';
import { sortProductObjects } from '../../utils/Utils';
import { localStoragePrefix } from './types';
import { useTranslation } from 'react-i18next';

const Shop = () => {
  const { t } = useTranslation();
  const [shopData, setShopData] = useState<any>({});
  const [products, setProducts] = useState<any>({});
  const productSplit = ['250', '251', '200'];
  const isLoading = useMemo(() => Object.entries(shopData).length === 0, [shopData]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // Get products from API, then update state / localStorage
    productsActions
      .getFormattedProducts()
      .then((newProducts) => {
        setProducts((oldProducts: any) => {
          if (JSON.stringify(oldProducts) === JSON.stringify(newProducts)) {
            return sortProductObjects(oldProducts, productSplit);
          }
          return sortProductObjects(newProducts, productSplit);
        });
        // Save products to cache after fetching
        const productsToCache = Object.keys(newProducts);
        localStorage.setItem(`${localStoragePrefix}-products`, JSON.stringify(productsToCache));
        Object.entries(newProducts).forEach(([productId, product]) => {
          localStorage.setItem(`${localStoragePrefix}-${productId}`, JSON.stringify(product));
        });
      })
      .catch((err) => {
        console.error('Failed to fetch products', err);
        setError(t('shop:errorLoadingProducts'));
      });
  }, [global.language, t]);

  const loadShopData = async () => {
    try {
      const categoryOrder = ['album', 'pictures', 'wall', 'coupon', 'subscription', 'product', 'card'];
      const data = await shopProductsAndCategorySelectorUpdated([], categoryOrder);
      setShopData(data);
    } catch (err) {
      console.error('Failed to load shop data', err);
      setError(t('shop:errorLoadingCategories'));
    }
  };

  useEffect(() => {
    loadShopData();
  }, []);

  if (error) {
    return (
      <div className="loading-container">
        <p>{error}</p>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="loading-container">
        <p>{t('common:loading')}</p>
      </div>
    );
  }

  return (
    <div className="shop-container">
      <ProductsContainer shopData={shopData} />
    </div>
  );
};

export default Shop;
